import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode5ZaraHome({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="ZARAHOME MARKA KARTI" />
}
